__turbopack_context__.v({
  "column": "grid-module__ZeTAuq__column",
  "fullRow": "grid-module__ZeTAuq__fullRow",
});
